<template lang="html">

  <div class="wrapper -conectados">

    <div class="encabezado">
      <div class="container column-start">
        <div class="contenedor-logo">
          <router-link to="/"><img src="/static/img/UFV-logo.png" alt="Logo UFV"></router-link>
        </div>
        <h1>Conectados</h1>
      </div>
    </div>

    <div class="migas">
      <div class="container">
        <nav class="row-start">
          <router-link to="/">Home</router-link>
          <router-link :to="$t('enlaces.conectados')">Conectados</router-link>
        </nav>
      </div>
    </div>

    <section class="proyecto-formativo -conectados">
      <div class="container column-center">
        <h2 class="big-bold-title">Conecta2</h2>
        <template v-if="active == 'profesional'">
          <p>El inicio de la carrera profesional es un momento de gran incertidumbre. El objetivo de Conecta2 es generar encuentros entre quienes en esta etapa buscan profundizar en su toma de decisiones y quienes ya habiendo pasado por ella pueden aportar su experiencia.  </p>  
          <p>¿Recuerdas tus primeros pasos profesionales? Seguro que sentiste algunos miedos, inseguridades o necesitaste orientación y acompañamiento. Tu trayectoria, experiencia y conocimientos son muy valiosos para quien ahora comienza. ¿Quieres apoyar a los jóvenes talentos? </p>
          <p>¿Te atreves a conectar? Inscríbete en el siguiente formulario:</p>
        </template>
        <template v-if="active == 'alumno' || !!!active">
          <p>El inicio de la carrera profesional es un momento de gran incertidumbre. El objetivo de Conecta2 es generar encuentros entre quienes en esta etapa buscan profundizar en su toma de decisiones y quienes ya habiendo pasado por ella pueden aportar su experiencia.</p>
          <p>Conocer en profundidad te ayuda a tomar decisiones. Si tienes dudas sobre un sector, industria, empresa. Te enfrentas a un proceso de selección y quieres información para prepararte bien... ante cualquier duda en las decisiones sobre tu carrera profesional, te ponemos en contacto con quien puede ayudarte.</p>
          <p>¿Te atreves a conectar? Inscríbete en el siguiente formulario:</p>
        </template>
      </div>
    </section>


    <section class="cuerpo-conectados row-center">
      <div class="contenedor-formulario-conectados container">
        <formulario></formulario>
      </div>
    </section>

    <section class="conectados-home">
      <div class="container row-between aic">
        <img src="/static/img/imagen-conectados.svg" class="imagen-conectados" alt="Imagen Conectados">
        <div class="text">
          <h2>¡Llámanos!</h2>
          <a href="tel:917091414">91 709 14 14 / Ext: 1242 / Ext:1243</a>

        </div>
      </div>

    </section>


  </div>

</template>

<script lang="js">

  import formulario from '@/components/view-parts/conectados/formulario'

  export default {
    name: 'conectados',
    mounted() {
      this.active = this.$route.params.id;
    },
    components: {
      'formulario': formulario
    },
    data() {
      return {
        active: 'alumno'
      }
    },
    watch: {
      '$route'() {
        this.active = this.$route.params.id;
      }
    }
  }
</script>

<style scoped lang="scss">
  .error-404 {}
</style>


// WEBPACK FOOTER //
// src/components/views/conectados.vue